// extracted by mini-css-extract-plugin
export default {"holderTopBar":"SeenCarModule_holderTopBar__8Lrj4"};